// src/components/AccountDashboard.js
import React from 'react';
import BalanceCard from './BalanceCard';
import TransactionList from './TransactionList';
import CategoryChart from './CategoryChart';

const AccountDashboard = ({ account }) => {
  return (
    <div className="account-dashboard">
      <h1>Tableau de bord</h1>
      <BalanceCard account={account} />
      <TransactionList account={account} />
      <CategoryChart account={account} />
    </div>
  );
};

export default AccountDashboard;
